import { getApiErrorBody, getApiErrorStatus } from './apiError';

const HTTP_UNPROCESSABLE_ENTITY = 422;

const BLOCK_HOME_CREATION_ACTION = 'block_home_creation';

const getErrorPayload = (error) =>
    getApiErrorStatus(error) === HTTP_UNPROCESSABLE_ENTITY ? getApiErrorBody(error) : null;

/**
 * Whether an API error is the legacy geo-restriction block on home creation/edition (EX-1011).
 * The server message is intentionally ignored: the displayed copy must stay generic (EX-1755).
 */
export const isGeoRestrictionBlockingError = (error) => {
    const errors = getErrorPayload(error)?.errors;
    if (!Array.isArray(errors)) {
        return false;
    }
    return errors.some(
        (restriction) => restriction?.blocking === true && restriction?.action === BLOCK_HOME_CREATION_ACTION
    );
};
